// header関連
if (document.querySelector('.global-header') !== null) {
  // menu開閉ボタン
  const globalHeader = document.querySelector('.global-header');
  const overlay = document.createElement('div');
  overlay.className = 'overlay';
  globalHeader.appendChild(overlay);
  document.querySelector('.js-menu-toggle').addEventListener('click', function f() {
    this.classList.toggle('is-menu-open');
    overlay.classList.toggle('is-active');
  });
  overlay.addEventListener('click', function f() {
    document.querySelector('.js-menu-toggle').classList.remove('is-menu-open');
    this.classList.remove('is-active');
  });

  // グロナビ開閉
  const globalMenuOpeners = document.querySelectorAll('.js-global-main-menu-toggle');
  for (let i = 0; i < globalMenuOpeners.length; i += 1) {
    globalMenuOpeners[i].addEventListener('click', function f() {
      this.classList.toggle('is-main-menu-open');
    });
  }

  ///言語選択モーダル////
  const langBtn = document.querySelector('.global-fixed-sub-nav__language-btn');
  const langModal = document.querySelector('.global-fixed-sub-nav__language-container');
  const langCloseBtn = document.querySelector('.global-fixed-sub-nav__language-close-btn');

  // 開く
  langBtn.addEventListener('click', () => {
    langModal.classList.add('is-active');
  });

  // 閉じる
  langCloseBtn.addEventListener('click', () => {
    langModal.classList.remove('is-active');
  });

  // 背景クリックで閉じる
  langModal.addEventListener('click', (e) => {
    if (e.target === langModal) {
      langModal.classList.remove('is-active');
    }
  });

  /// Google検索モーダル //////
  const searchOpenBtn = document.querySelector('.search-open-btn');
  const searchModal = document.querySelector('.search-modal__overlay');
  const searchCloseBtn = document.querySelector('.search-modal__close-btn');

  if (searchOpenBtn && searchModal && searchCloseBtn) {
    // 開く
    searchOpenBtn.addEventListener('click', () => {
      searchModal.classList.add('is-active');
      // 描画を確実にするため、少し長めの待機時間を設ける（例: 300ms）
      setTimeout(() => {
        const searchInput = document.querySelector('input.gsc-input');
        if (searchInput) {
          searchInput.focus();
        }
      }, 300);
    });

    // 閉じる
    searchCloseBtn.addEventListener('click', () => {
      searchModal.classList.remove('is-active');
    });

    // 背景クリックで閉じる
    searchModal.addEventListener('click', (e) => {
      if (e.target === searchModal) {
        searchModal.classList.remove('is-active');
      }
    });
  }

  ///SNSモーダル//////
  document.querySelectorAll('.js-sns-btn').forEach((btn) => {
    const modal = btn.closest('[class$="__sns"]').nextElementSibling;
    if (!modal) return;

    const closeBtn = modal.querySelector('.js-sns-close');

    // 開く
    btn.addEventListener('click', () => {
      modal.classList.add('is-active');
    });

    // 閉じる
    closeBtn.addEventListener('click', () => {
      modal.classList.remove('is-active');
    });

    // 背景クリックで閉じる
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.classList.remove('is-active');
      }
    });
  });
}
